import React, { useState, useEffect } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import image from './image.png'
import { useNavigate } from 'react-router-dom';
import MapChart from './MapChart';
import ecimpact from './assets/img/ecimpact.svg'
import Tooltip from '@mui/material/Tooltip';
import info from './info.svg'
import Textarea from '@mui/joy/Textarea';
import axios from 'axios';
import Navbar from "./Navbar";
import { CircularProgress } from "@mui/joy";




const EVALUATE_URL =
  "https://us-central1-jetforce-1d009.cloudfunctions.net/evaluateAnswer";

export default function Question10() {
  const navigate = useNavigate();
  const [question10, setQuestion10] = useState("");
  const [loading, setLoading] = useState(false);
  const [summaryError, setSummaryError] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem("Question10");
    if (!question10 && saved) setQuestion10(saved);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQuestion10Change = (e) => setQuestion10(e.target.value);

  const extractContent = (data) =>
    data?.choices?.[0]?.message?.content ?? data?.content ?? data?.result ?? "";

  const buildQASnapshot = () => {
    const qa = [];
    for (let i = 1; i <= 10; i++) {
      qa.push({
        question: localStorage.getItem(`Question${i}`) || "",
        answer: localStorage.getItem(`Answer${i}`) || "",
      });
    }
    return qa;
  };

  const sendMessage = async () => {
    const input = `
Question: Will communities have ownership or a stake in the technology, either in terms of financial returns or decision-making? If so, how?

Answer: ${question10}

Provide only a total score percentage for the answer based on the following criteria:
Relevance, Particularity, Expertise, Effect, Value, Innovation, Expediency, Track record, Commitment, Clarity, and Professionalism.

Your response should not exceed 80 words. Don't give only the score but also a clarification.
`;

    const answer = await axios.post(EVALUATE_URL, { task: "score", input });

    const content = extractContent(answer.data);
    if (!content) throw new Error("Empty evaluateAnswer content (score)");

    localStorage.setItem("Answer10", content);
    localStorage.setItem("Question10", question10);

    return content;
  };

  const generateSummary = async () => {
    const qa = buildQASnapshot();

    const missing = qa.some((x) => !x.question.trim() || !x.answer.trim());
    if (missing) throw new Error("Missing Q/A pairs in localStorage");

    const input = `
You are an evaluator. You will be given 10 Q/A pairs from a user.
Return EXACTLY 10 lines max 200 words.
Each line must start with "- ".
Each line must be specific and actionable: what to improve + how to fix it.
Avoid generic advice.
Focus on repeated weaknesses across answers.

Q/A:
${qa
  .map((x, idx) => `Q${idx + 1}: ${x.question}\nA${idx + 1}: ${x.answer}`)
  .join("\n\n")}
`;

    const res = await axios.post(EVALUATE_URL, { task: "summary", input });

    const summaryText = extractContent(res.data);
    if (!summaryText) throw new Error("Empty evaluateAnswer content (summary)");

    localStorage.setItem("Summary", summaryText);
    return summaryText;
  };

  const Nextpage = async () => {
    if (!question10.trim() || loading) return;

    setLoading(true);
    setSummaryError("");

    try {
      // 1) Score Q10 (MUST succeed)
      await sendMessage();

      // 2) Summary (MUST succeed)
      await generateSummary();

      // 3) Verify saved
      const saved = localStorage.getItem("Summary");
      if (!saved) throw new Error("Summary was not saved to localStorage");

      navigate("/Score");
    } catch (err) {
      console.error(err);
      setSummaryError(err?.message || "Summary failed");
    } finally {
      setLoading(false);
    }
  };

  const retrySummaryOnly = async () => {
    setLoading(true);
    setSummaryError("");
    try {
      await generateSummary();
      const saved = localStorage.getItem("Summary");
      if (!saved) throw new Error("Summary was not saved to localStorage");
      navigate("/Score");
    } catch (err) {
      console.error(err);
      setSummaryError(err?.message || "Summary failed again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <br />
      <div className="container">
        <div style={{ float: "right" }}>
          <h4 style={{ float: "inline-start", color: "whitesmoke", paddingRight: "10px" }}>
            Progress
          </h4>
          <CircularProgress sx={{ color: "#0e8d93" }} size="lg" determinate value={92.9}>
            <p style={{ color: "whitesmoke" }}>92.9%</p>
          </CircularProgress>
        </div>

        <div className="center" id="mobile">
          <br />
          <div
            id="container3"
            style={{ borderRadius: "10px", backgroundColor: "#ececec", marginTop: "100px" }}
          >
            <div>
              <h4 style={{ color: "#139ca3" }} className="question">
                Question #10
              </h4>
              <p>
                Will communities have ownership or a stake in the technology, either in terms of financial returns or
                decision-making? If so, how?
              </p>

              <h4 className="question" style={{ color: "#139ca3" }}>
                Answer
              </h4>

              <Textarea
                minRows={5}
                style={{ maxWidth: "100%" }}
                value={question10}
                onChange={handleQuestion10Change}
                disabled={loading}
              />
              <br />
            </div>

            <div className="links">
              <button className="follow" type="button" onClick={() => navigate("/Question9")} disabled={loading}>
                Back
              </button>

              <button
                className="follow"
                type="button"
                style={{ float: "right" }}
                onClick={Nextpage}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
